import Permissions from "../../models/Permissions";

const Index = () => import("./Index.vue");
const Form = () => import("./Form.vue");
const UsuarioEmpresas = () => import("./UsuarioEmpresas.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const children = [
  {
    path: "cadastro",
    name: "usuario.cadastro",
    component: Form,
    meta: {
      requiresAuth: true,
      requiresCompany: false,
      showInMenu: true,
      label: "Cadastro",
      icon: "fa fa-file",
      group: "Cadastros",
      permissions,
    },
  },
  {
    path: "empresa",
    name: "usuario.empresa",
    component: UsuarioEmpresas,
    meta: {
      requiresAuth: true,
      requiresCompany: false,
      showInMenu: true,
      label: "Ligar Empresa",
      icon: "fa fa-file",
      group: "Cadastros",
      permissions,
    },
  },
];

export default [
  {
    path: "/usuario",
    component: Index,
    meta: {
      requiresAuth: true,
      requiresCompany: false,
      showInMenu: true,
      label: "Usuários",
      icon: "fa fa-users",
      group: "Cadastros",
      permissions,
    },
    children,
  },
];
